import { UserRole } from '@/store/auth/types';
import { isAdminRole, isAgentOrAgencyRole, isPartnerRole, isUniStaffRole } from '@/utilities/roles/permissions';

export const usedByAgent = (role: UserRole): boolean => isAgentOrAgencyRole(role);
export const usedByPartner = (role: UserRole): boolean => isPartnerRole(role);
export const usedByUniStaff = (role: UserRole): boolean => isUniStaffRole(role) || isAdminRole(role);
